import ApplicationAdapter from "./application";

export default class DnsRecordAdapter extends ApplicationAdapter {
  urlForCreateRecord(_, snapshot) {
    return `${this.apiBaseUri}/domain/addrecord?domainname=${snapshot.belongsTo("domain").id}`;
  }

  urlForUpdateRecord(id) {
    return `${this.apiBaseUri}/domain/updaterecord?recordid=${id}`;
  }

  urlForDeleteRecord(id) {
    return `${this.apiBaseUri}/domain/deleterecord?recordid=${id}`;
  }
}
